module.exports = function isBoolean(x) {
  return x === true || x === false;
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/tcomb/lib/isBoolean.js
// module id = 445
// module chunks = 0